import { Button } from "@material-ui/core";
import clsx from "clsx";
import { theme } from "config/theme";
import { COLORS } from "constants/colors";
import { ReactElement } from "react";
import styled from "styled-components";

const SwitchBox = styled.div<{ checkedColor: string; uncheckedColor: string; customWidth: string }>`
  width: 330px;
  height: 41px;
  border-radius: 26px;
  background-color: #e2f4fb;
  display: flex;
  position: relative;

  & .MuiButton-root {
    height: inherit;
    flex: 1;
    z-index: 2;
    color: #399ebf;
    border-radius: 26px;
  }

  &.checked::after {
    content: "";
    width: 50%;
    border-radius: 26px;
    background-color: ${(props) => props?.checkedColor || COLORS.primary};
    position: absolute;
    box-shadow: 0 6px 6px 0 rgba(0, 0, 0, 0.16);
    transform: translateX(0px);
    -webkit-transition: 0.4s;
    transition: 0.4s;
    position: absolute;
    border: solid 1px ${(props) => props?.checkedColor || COLORS.primary};
    top: -1px;
    bottom: -1px;
  }

  &.unchecked::after {
    content: "";
    width: 50%;
    top: -1px;
    bottom: -1px;
    right: 68%;
    border-radius: 26px;
    background-color: ${(props) => props?.checkedColor || COLORS.primary};
    position: absolute;
    box-shadow: 0 6px 6px 0 rgba(0, 0, 0, 0.16);
    transform: translateX(${(props) => (props?.customWidth ? `${parseInt(props?.customWidth, 10) / 2}px` : "165px")});
    -webkit-transition: 0.4s;
    transition: 0.4s;
    position: absolute;
    ${theme.breakpoints.down("xs")} {
      right: 223px;
    }
  }

  &.checked .btnchecked {
    -webkit-transition: 0.4s;
    transition: 0.4s;
    color: #fff;
    font-weight: 700;
  }

  &.unchecked .btnunchecked {
    -webkit-transition: 0.4s;
    transition: 0.4s;
    color: #fff;
    font-weight: 700;
  }
`;
interface SwitchLabelProps {
  label: string;
  icon?: ReactElement;
  checked?: boolean;
}

interface SwitchPros {
  primary: SwitchLabelProps;
  secondary: SwitchLabelProps;
  checkedColor?: string;
  uncheckedColor?: string;
  onChange?: (checked: boolean) => void;
  customWidth?: string;
}
export default function Switch({
  primary,
  secondary,
  checkedColor,
  uncheckedColor,
  onChange,
  customWidth,
}: SwitchPros) {
  const handleChange = () => {
    primary.checked = !primary.checked;
    onChange && onChange(primary.checked);
  };

  return (
    <SwitchBox
      className={clsx({
        checked: primary.checked,
        unchecked: !primary.checked,
      })}
      checkedColor={checkedColor}
      uncheckedColor={uncheckedColor}
      customWidth={customWidth}
    >
      <Button
        className={clsx({
          btnchecked: primary.checked,
        })}
        onClick={handleChange}
        style={{ backgroundColor: `${primary.checked ? checkedColor : uncheckedColor}` }}
      >
        {primary.label}
      </Button>

      <Button
        className={clsx({
          btnunchecked: !primary.checked,
        })}
        onClick={handleChange}
      >
        {secondary.label}
      </Button>
    </SwitchBox>
  );
}
